export default __webpack_public_path__ + "static/media/testSeriesIcon.5fadef7f.svg";